import { BaseService } from "@/api/baseService";
import httpRequest from "@/api/index";
import type { CustomerEnterpriseVo, Page } from "../../../entity";
import type { CustomerSmsSettingVo } from "@zhihaoscm/entity";

export class SubManagementService extends BaseService<any, any, any, any> {
    // 查询受邀记录
    async getInvitedList(params: { page: number; size: number; state: number }): Promise<Page<CustomerEnterpriseVo>> {
        const { data } = await this.service.get(`${this.path}/invited/paging`, { params });
        return data;
    }

    // 查询邀请记录,传入`已确认`状态则查询子账号列表
    async getSubAccountList(params: {
        page: number;
        size: number;
        sortKey: string;
        sortDirection: string;
        state?: number;
        searchParam?: string;
        accountState?: number;
    }): Promise<Page<CustomerEnterpriseVo>> {
        const { data } = await this.service.get(`${this.path}/paging`, { params });
        return data;
    }

    // 邀请子账号
    async addSubAccount(params: { mobile: string; roles: number[] }): Promise<Page<CustomerEnterpriseVo>> {
        const { data } = await this.service.post(`${this.path}`, params);
        return data;
    }

    // 删除子账号
    async deleteSubAccount(id: number, operationType: number): Promise<Page<CustomerEnterpriseVo>> {
        const { data } = await this.service.delete(`${this.path}/remove/${id}?operationType=${operationType}`, {});
        return data;
    }

    // 确认邀请
    async confirm(id: number, state: number): Promise<any> {
        const { data } = await this.service.put(`${this.path}/confirm/${id}?state=${state}`, {});
        return data;
    }

    // 拒绝邀请
    async reject(id: number, state: number): Promise<any> {
        const { data } = await this.service.put(`${this.path}/confirm/${id}?state=${state}`, {});
        return data;
    }

    // 获取子账号详情
    async getSubAccountDetail(id: number): Promise<CustomerEnterpriseVo> {
        // 小程序由于受邀记录和子账号信息邀请记录详情用的同一个接口，要区分账号信息是子账号还是主账号的，用户PC只有子账号信息有详情所以写死查子账号信息
        enum QueryType {
            // 查询子账号
            SUB_ACCOUNT = 2
        }
        const { data } = await this.service.get(`${this.path}/find/vo/${id}?queryType=${QueryType.SUB_ACCOUNT}`);
        return data;
    }

    // 登入的是子账号获取子账号详情
    async getSubAccountDetailOnSub(): Promise<CustomerEnterpriseVo> {
        const { data } = await this.service.get(`${this.path}/find/self/vo`);
        return data;
    }

    // 编辑子账号
    async editSubAccount(
        id: number,
        params: { roles: number[]; receiptSms: number; accountState: number }
    ): Promise<Page<CustomerEnterpriseVo>> {
        const { data } = await this.service.put(`${this.path}/${id}`, params);
        return data;
    }

    // 获取短信管理用户及子账号数据
    async getSubInvitedList(): Promise<CustomerEnterpriseVo[]> {
        const { data } = await this.service.get(`${this.path}/invited/list`);
        return data;
    }

    // 获取短信管理用户及子账号数据
    async getCustomerAndSub(params: { searchParams?: string }): Promise<{ customerSmsVos: CustomerSmsSettingVo[] }> {
        const { data } = await this.service.get(`/customer/get/customerAndSub`, { params });
        return data;
    }

    // 保存短信设置
    async getCustomerAndSubSave(customerSmsVos: CustomerSmsSettingVo[]): Promise<any> {
        const { data } = await this.service.post(`/customer/get/customerAndSub/save`, { customerSmsVos });
        return data;
    }
}

export const subManagementService = new SubManagementService("/customer/sub", httpRequest);
